import React from "react";

import { Container } from "react-bootstrap";
import FadeUpTrigger from "../animation/FadeUpTrigger";

import HeaderNormal from "../components/header/HeaderNormal";
import BoxRight from "../components/box-right/BoxRight";
import TitleSection from "../components/heading/TitleSection";
// import ServiceTow from "../components/services/ServiceTow";
// import Team from "../components/team/Team";
// import BrandClient from "../components/brand-client/BrandClient";
import NextPageContent from "../components/next/NextPageContent";
import Footer from "../components/footer/Footer";
import TestimonialTow from "../components/testimonial/TestimonialTow";
import { Helmet } from 'react-helmet-async';

const headerContent = {
  title: "Who we are",
  description: `We are committed to providing improved, effective quality solutions and services to our customers through transparency and
    collaboration, achieving continual excellence in all our products & services through our committed, motivated and dynamic team.`,
};

function About() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - About Us </title>
        <link rel='canonical' href='/about' />
      </Helmet>

      {/*Start Header*/}
      <HeaderNormal
        className="background-section"
        description={headerContent.description}
      >
        {headerContent.title}
      </HeaderNormal>

      {/*Start Box Right Info*/}
      <BoxRight
        className="mb-section text-center"
        src="/assets/img/team.jpg"
        parallaxFrom={{ scale: 1.2 }}
        parallax={{ scale: 1 }}
        overlay={4}
      >
        <FadeUpTrigger>
          <h2>
            Hello we are, <br /> Devlift.
          </h2>
          <p className="mt-30 m-w750 dsn-auto">
            At Devlift we maintain a daily commitment to excellence with our
            approach to design, development and solving business problems. We
            are confident in our ability to deliver a strategy and product that
            engages your desired audience and in turn, allows you to reach your
            business goals.
          </p>
          <p className="mt-30 m-w750 dsn-auto">
            Our user-centric approach ensures that our work has the greatest
            possible impact with its’ intended audiences. We produce effective
            solutions that balance audience needs with client requirements to
            deliver specialized tech solutions.
          </p>
          <p className="mt-30 m-w750 dsn-auto">
            Most importantly, as your valued partner, we believe one of our key
            roles is to ensure transparency and collaboration between ourselves
            and all stakeholders. We know that by cultivating a culture of
            openness, we can deliver optimal performances by keeping everyone
            focused on the big picture.
          </p>
        </FadeUpTrigger>
      </BoxRight>
      {/*End Box Right Info*/}

      {/*Start Service Section*/}
      {/* <Container className="section-margin">
        <TitleSection description="Our Services">
          New Branding Agency
        </TitleSection>
        <ServiceTow col={2} colMobile={1} />
      </Container> */}
      {/*End Service Section*/}

      {/*Start Team*/}
      {/* <section className="section-margin background-section section-padding">
        <Container className="dsn-right-container">
          <TitleSection description="our team">
            Meet the team
          </TitleSection>
          <Team loop grabCursor />
        </Container>
      </section> */}
      {/*End Team*/}

      {/*Start Service Section*/}
      <Container className="section-margin">
        <TitleSection description="FeedBack">
          What our clients are saying
        </TitleSection>
        <TestimonialTow grabCursor loop />
      </Container>
      {/*End Service Section*/}

      {/*Start Brand*/}
      {/* <Container className="section-margin">
        <TitleSection description="Our clients">
          Your successful, our <br /> reputation
        </TitleSection>
        <BrandClient col={3} colTablet={2} colGap={2} rowGap={2} />
      </Container> */}
      {/*End Brand*/}

      <NextPageContent className="section-margin" />
      <Footer />
    </React.Fragment>
  );
}

export default About;
